module.exports = {"title":"IRWIN Observer Preferences","description":"IRWIN Observer Web Application Preferences","type":"Web Mapping Application","tags":"Irwin","typeKeywords":"IRWIN.Observer.Preferences","text":"{}"}


//////////////////
// WEBPACK FOOTER
// ./src/defaults/userPreferencesItem.json
// module id = 867
// module chunks = 0